import {Header, RecipesComponent} from "./components";

const App = () => {

    return (
        <div>
            <Header/>
            <RecipesComponent/>
        </div>
    );
};

export {App};
